<style scoped lang="less">
  @import "../styles/color";

  .grid {
    /*display: none;*/
    width: 100%;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 15px 20px 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.has-border {
      border: 2px solid #eee;
      padding-left: 20px;
    }

    .grid-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .name {
        display: flex;
        align-items: center;
        color: #000;
        font-size: 24px;
        cursor: pointer;

        &.bold {
          font-weight: bolder;
        }
      }

      .living-entry {
        > div {
          width: 120px;
          height: 24px;
          border: 1px solid #999;
          border-radius: 5px;
          color: #999;
          float: left;
          text-align: center;
          line-height: 21px;
          margin-left: 20px;
          cursor: pointer;
        }

        .living-online {
          color: #fff;
          background: red;
          border-color: red;
        }
      }
    }

    .grid-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .grid-content-l {
        width: 55%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 20px 0 0;

        &.w50 {
          width: 50%;
        }

        .info {
          li {
            margin-bottom: 15px;
            color: #999;
          }
        }

      }

      .grid-content-r {
        width: 30%;
        margin-top: 20px;

        &.w50 {
          width: 50%;
        }

        &.demand {

          li {
            width: 45%;
            border: 2px solid #eee;
            border-radius: 5px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
            }
          }
        }

        &.exhibition {
          li {
            width: 115px;
            height: 115px;
            border: 1px solid #ddd;
            border-radius: 5px;

            img {
              width: 115px;
              height: 85px;
              border-radius: 0 0 5px 5px;
            }

            p {
              line-height: 24px;
              text-align: center;
              color: #999;
              font-size: 14px;
            }
          }
        }

        ul {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
        }
      }
    }

    .action {
      width: 100%;
      margin-top: 10px;

      > div {
        float: left;
        line-height: 30px;
        margin-right: 20px;
        cursor: pointer;

        img {
          width: 22px;
          height: 22px;
          vertical-align: sub;
        }

        &.reservation {
          float: right;
          width: 100px;
          height: 30px;
          background: red;
          color: #fff;
          letter-spacing: 3px;
          text-align: center;
          border-radius: 5px;
          margin-right: 30px;
          line-height: 28px;
          cursor: pointer;

          &.reservation-ex {
            background: #fff;
            color: #999;
            border: 1px solid #ddd;
          }
        }

      }

      &.purchaser {
        width: 45%;
        float: right;

        > div {
          float: right;
        }

        .reservation {
          margin: 0 0 0 10px;
        }
      }
    }

    .hot {
      img {
        width: 22px;
        height: 22px;
        vertical-align: sub;
      }

      span {
        color: #999;
        line-height: 1;
      }
    }
  }

  .hot .iconfont {
    color: @primaryColor;
  }
</style>
<!--展商的item-->
<template>
  <div class="grid has-border">
    <div class="grid-header">
      <div
        class="name bold"
        @click="viewDetail(info.id)"
      >
        {{info.name}}
      </div>
      <div class="hot">
        <i class="iconfont icon-fire" style="font-size: 30px;"></i>
        <!--        <img :src="hotIcon" alt="">-->
        <span class="ico">{{info.popular}}</span>
      </div>
      <div class="living-entry" v-if="type === 'exhibition'">
        <div class="living-online">
          {{$t('lang.正在直播')}}
        </div>
        <div class="living-history">
          {{$t('lang.展商风采')}}
        </div>
      </div>
    </div>
    <div class="grid-content">
      <div class="grid-content-l w50">
        <ul class="info">
          <li>{{info.first}}</li>
          <li>{{info.second}}</li>
          <li>{{info.third}}</li>
        </ul>
        <div class="action">
          <div class="hot">
            <img :src="hotIcon" alt="">
            <span class="ico">{{info.popular}}</span>
          </div>
          <div class="like">
            <img :src="info.like ? likeIconSelected : likeIcon" alt="">
          </div>
          <div class="collect"><img :src="info.collect ? collectIconSelected : collectIcon" alt=""></div>
<!--          <div class="message"><img :src="messageIcon" alt=""></div>-->
          <messageButton :online="info.online" type="0"></messageButton>
          <div class="reservation" :class="{'reservation-ex': type === 'exhibition'}">{{$t('lang.预约')}}</div>
        </div>
      </div>
      <div class="grid-content-r exhibition w50">
        <ul>
          <li>
            <img :src="info.image1 || exhibits_d" alt="">
            <p>{{$t('lang.展品名称')}}</p>
          </li>
          <li>
            <img :src="info.image2 || exhibits_d" alt="">
            <p>{{$t('lang.展品名称')}}</p>
          </li>
          <li>
            <img :src="info.image3 || exhibits_d" alt="">
            <p>{{$t('lang.展品名称')}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import * as   routerUtil from "@common/utils/routerUtil";
  import {formatTags, isNil, tagNameWithLang} from "../../common/utils";
  import {str2array} from "../utils";

  export default {
    props: {
      info: {type: Object}
    },
    methods: {     //go2Detail 查看详情
      go2Detail(item) {
        // 采购商 ppcgs
        // 需求 ppxq
        //展商 cgs
        //  展品  zp
        routerUtil.push(`/user/yiwu/exhibitor/${item.id}`)
        return false
      },
      tagNameWithLang(tagName) {
        return tagNameWithLang(tagName)
      },
      tags_(info) {
        var tagNames = info.tagNames
        var tags = info && info.tags && info.tags.filter && info.tags.filter(item => !isNil(item))
        var tags_ = str2array(tags).map(item => {
          var item_ = formatTags(item)
          return item_
        }).filter(item => !isNil(item))
        var result = require('lodash.uniq')(tagNames, tags_)
        return result
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/wenxing/components/exhibitionItem.vue